__turbopack_context__.v({
  "className": "manrope_b112a7de-module__lvq8ZG__className",
});
